import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('siteGroup', [
    'GET_ALL',
    'UPDATE',
    'CREATE',
    'DELETE',
    'SYNCGROUP',
    'SYNCGROUP_RESET'
]);

export const initialSiteGroupState = {
    ...generateDefaultState('siteGroup', [
        'GET_ALL',
        'UPDATE',
        'CREATE',
        'DELETE',
        'SYNCGROUP',
        'SYNCGROUP_RESET'
    ]),
};